module.exports = __webpack_public_path__ + "assets/img/teacher (25).560ca9c4.png";